import React from 'react';
import hydraulic from './images/hydraulic.jpg';
import '../style.css';

const Hydraulic = () => {
    return (
        <>
            <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', backgroundImage: `url('${hydraulic}')`, backgroundSize: 'cover', backgroundPosition: 'center', color: 'white', minHeight: '250px' }}>
                <h1 style={{ textShadow: '1px 1px 4px rgba(0,0,0,0.8)' }}>Our Hydraulic Hybrid Technology</h1>
            </div>
            <div className='blog'>
                <div className='blog-project1'>
                    <p>
                        OctoNexus Power's hydraulic hybrid technology draws inspiration from nature's most efficient fluid systems. By combining hydraulic energy recovery with renewable power generation, we capture and reuse energy that would otherwise be lost in industrial and marine applications.
                    </p>
                    <p>
                        Our hydraulic systems store energy in pressurised accumulators, enabling rapid charge and discharge cycles with very high round-trip efficiency. This makes them particularly suited to applications with variable or intermittent power demands — such as cranes, offshore equipment, and heavy vehicles.
                    </p>
                    <p>
                        Integrated with our HydroVerra platform, hydraulic hybrid modules provide an additional layer of energy resilience — bridging the gap between generation peaks and demand spikes without relying on battery chemistry or grid connectivity.
                    </p>
                    <p>
                        Want to learn how hydraulic hybridisation can improve your energy efficiency? <a href="/contactus" style={{ color: '#0fa19a' }}>Get in touch</a> with our engineering team.
                    </p>
                </div>
                <div className='blog-project2'>
                    <h2>Key Advantages</h2>
                    <ul>
                        <li>High power density with fast charge/discharge cycles</li>
                        <li>Long operational lifespan with minimal degradation</li>
                        <li>Biomimetic design for optimal fluid dynamics</li>
                        <li>Reduces peak demand on primary power sources</li>
                        <li>Suited for harsh marine and industrial environments</li>
                    </ul>
                </div>
            </div>
        </>
    );
};
export default Hydraulic;
